module.exports = __webpack_public_path__ + "assets/img/diploma-100px.4321e990.png";